<template>
    <div class="agencyCenterListBox">
        <div class="situationList" v-show="agencyOrOver">
            <div class="situationListItem">
                <div class="situationTopBox">
                    <h4 class="situationTitle">评分任务待审核</h4>
                    <div class="situationBtn">立即处理</div>
                </div>
                <ul class="situationDatailList">
                    <li>
                        <div class="detailTitle">任务名称：</div>
                        <div class="situationData">2019年第一季度涉旅经营户品…</div>
                    </li>
                    <li>
                        <div class="detailTitle">涉及行业类别：</div>
                        <div class="situationData">酒店、餐饮、租赁车</div>
                    </li>
                    <li>
                        <div class="detailTitle">目标完成时间：</div>
                        <div class="situationData">22019-11-22</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="overList" v-show="!agencyOrOver">
            <div class="overListItem">
                <div class="overListTopBox">
                    <h4 class="overListTitle">待线下评分整改</h4>
                    <div class="overListBtn">已知悉</div>
                </div>
                <ul class="overListDatailList">
                    <li>
                        <div class="overListDetailTitle">企业名称：</div>
                        <div class="overListData">2019年第一季度涉旅经营户品…</div>
                    </li>
                    <li>
                        <div class="overListDetailTitle">所属辖区：</div>
                        <div class="overListData">这里是一段审核意见的文字这是一段…</div>
                    </li>
                    <li>
                        <div class="overListDetailTitle">进入重点关注时间：</div>
                        <div class="overListData">2019-11-23 10:24</div>
                    </li>
                    <li>
                        <div class="overListDetailTitle">处理时间：</div>
                        <div class="overListData">2019-11-23 10:24</div>
                    </li>
                    <li>
                        <div class="overListDetailTitle">处理人：</div>
                        <div class="overListData">王小明</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AgencyCenterList',
        props: {
            pAgencyOrOver: Boolean
        },
        data () {
            return {
                agencyOrOver: true
            }
        },
        methods: {

        },
        watch: {
            pAgencyOrOver (val) {
                console.log(val)
                if (val) {
                    this.agencyOrOver = true
                } else {
                    this.agencyOrOver = false
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .agencyCenterListBox{
        width: 100%;

        .situationList{
            .situationListItem{
                width: 100%;
                height: 134px;
                margin-bottom: 16px;
                padding: 12px 16px 0;
                background-color: #fff;
                border-radius:3px;

                .situationTopBox::after{
                    content: '';
                    display: block;
                    clear: both;
                }

                .situationTopBox{
                    height: 28px;
                    margin-bottom: 8px;

                    .situationTitle{
                        font-size: 14px;
                        font-weight: bold;
                        line-height: 28px;
                        float: left;
                    }

                    .situationBtn{
                        width: 64px;
                        height: 28px;
                        font-size: 12px;
                        text-align: center;
                        line-height: 28px;
                        color: #fff;
                        background-color: #36B374;
                        border-radius:2px;
                        float: right;
                    }
                }

                .situationDatailList{

                    >li::after{
                        content: '';
                        display: block;
                        clear: both;
                    }

                    >li{
                        height: 22px;

                        .detailTitle{
                            width: 110px;
                            font-size: 14px;
                            line-height: 22px;
                            color: #999;
                            float: left;
                        }

                        .situationData{
                            margin-left: 110px;
                            font-size: 14px;
                            line-height: 22px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }

        .overList{
            .overListItem{
                width: 100%;
                height: 172px;
                margin-bottom: 16px;
                padding: 12px 16px 0;
                background-color: #fff;
                border-radius:3px;

                .overListTopBox::after{
                    content: '';
                    display: block;
                    clear: both;
                }

                .overListTopBox{
                    height: 28px;
                    margin-bottom: 8px;

                    .overListTitle{
                        font-size: 14px;
                        font-weight: bold;
                        line-height: 28px;
                        float: left;
                    }

                    .overListBtn{
                        width: 64px;
                        height: 28px;
                        font-size: 14px;
                        text-align: center;
                        line-height: 28px;
                        color: #999999;
                        // background-color: #36B374;
                        border-radius:2px;
                        float: right;
                    }
                }

                .overListDatailList{

                    >li::after{
                        content: '';
                        display: block;
                        clear: both;
                    }

                    >li{
                        height: 22px;

                        .overListDetailTitle{
                            font-size: 14px;
                            line-height: 22px;
                            color: #999;
                            float: left;
                        }

                        .overListData{
                            // width: 209px;
                            margin-left: 72px;
                            font-size: 14px;
                            line-height: 22px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }
</style>
